<template>
  <div>
    <Page :title="pageTitle">
      <!-- <template v-slot:action> </template> -->
      <template v-slot:default>
        <div class="flex flex-col max-w-7xl mx-auto my-10">
          <ReviewsList></ReviewsList>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Page from "../components/Common/Page";
import ReviewsList from "../components/Reviews/ReviewsList.vue";

export default {
  components: {
    Page,
    ReviewsList
  },
  data() {
    return {
      pageTitle: "Reviews"
    };
  }
};
</script>

<style lang="scss" scoped></style>
